import React from "react";
import '../css/LegalPages.css';

export default function PaymentTerms() {
  return (
    <div className="legal-page">
      <h1>Betalingsbetingelser</h1>

      <h2>1. Betaling</h2>
      <p>
        Alle betalinger til Linx Legacy Academy foregår via Stripe. Vi håndterer
        ikke dine kortoplysninger direkte, og al betaling er krypteret.
      </p>

      <h2>2. Kontingent og medlemskab</h2>
      <p>
        Betaling for holdtræning dækker den aftalte periode (fx 6 måneder). Medlemskabet
        starter først, når betalingen er gennemført.
      </p>
      <ul>
        <li>Kontingent skal betales forud.</li>
        <li>Hvis betalingen ikke gennemføres, kan adgang til holdtræning og events suspenderes.</li>
        <li>Priser fremgår altid på vores hjemmeside og kan ændres med forudgående varsel.</li>
      </ul>

      <h2>3. Refundering og aflysning</h2>
      <ul>
        <li>Prøvetime: Gratis prøvetime tilbydes før opstart af medlemskab.</li>
        <li>Opsigelse: Medlemskab kan opsiges ved periodens afslutning. Der ydes ingen refusion for delvist forløb.</li>
        <li>Force majeure: I tilfælde af aflysning af træning eller events (fx COVID-19, tekniske problemer) refunderes betaling efter vores skøn, eller træningen tilbydes på et andet tidspunkt.</li>
      </ul>

      <h2>4. Ansvar</h2>
      <p>
        Linx Legacy Academy er ikke ansvarlig for tab af data, udeblivelse, eller skader under deltagelse i online eller fysiske træninger. Deltagelse sker på eget ansvar.
      </p>

      <h2>5. Kontakt</h2>
      <p>
        Ved spørgsmål om betaling kan du kontakte os på 
        <a href="mailto: Academy@linxlegacy.dk"> Academy@linxlegacy.dk</a>.
      </p>
    </div>
  );
}